import useFetchResource from '../useFetchResource';
import api from 'libs/api';

export interface IPublicAccount {
  id: number;
  name: string;
  subdomain: string;
  parking_unit_must_provided: boolean;
  parking_can_reservation_days: number;
  parking_must_approved: boolean;
  parking_time_limit?: number;
  parking_start_working?: string | null;
  parking_end_working?: string | null;
  location_country_id: number;
  time_zone?: string | null;
}

export default function useGetPublicAccount(guid?: string) {
  const {
    resource: account,
    fetchResource: fetchAccount,
    isLoading,
  } = useFetchResource<IPublicAccount>({
    api: api.account.public,
    initialParams: { guid },
    initialValues: {
      id: 0,
      name: '',
      subdomain: '',
      parking_must_approved: false,
      parking_unit_must_provided: false,
      parking_can_reservation_days: 0,
      location_country_id: 0,
    },
    useNotFound: true,
  });

  return { account, fetchAccount, isLoading };
}
